// extracted by mini-css-extract-plugin
export var deliveryRow = "_rj-a";
export var fixedHeight = "_rj-4";
export var freightLogo = "_rj-9";
export var fullWidth = "_rj-3";
export var priceColumn = "_rj-5";
export var radioSelected = "_rj-7";
export var radioUnselected = "_rj-6";
export var selectedOption = "_rj-2";
export var selectedOptionContainer = "_rj-1";
export var selection = "_rj-0";
export var tallSkeletonText = "_rj-8";